/* eslint-disable no-unused-vars */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "babel-polyfill";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

const global = require("@/utils/global");
Vue.prototype.$global = global;

import axios from "axios";
import VueAxios from "vue-axios";
import {
  Checkbox,
  Input,
  RadioGroup,
  RadioButton,
  Upload,
  Dialog,
  Button,
  Select,
  Option,
  Message,
  Notification,
  Table,
  TableColumn,
  Loading,
} from "element-ui";

Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios);
Vue.use(Checkbox);
Vue.use(Input);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Loading);
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
